/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "ngtzynyftkludythcpqm"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ndHp5bnlmdGtsdWR5dGhjcHFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1OTk3NTIsImV4cCI6MjA5MDE3NTc1Mn0.wuBpxvKLknnPnfjwk5lW9DExMf7gAzXL5S41N0XlUNo"